import { render } from "./NhomTuVan.vue?vue&type=template&id=55ee8b60"
import script from "./NhomTuVan.vue?vue&type=script&lang=js"
export * from "./NhomTuVan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__